<template>
    <div class="project-list">
        <div class="module-header v-center space-between">
            <h1 class="module-name v-center">
                Factories
            </h1>
            <div class="v-center add-btn">
                <button v-if="canCreate" class="btn pointer" @click="openCreateFactory">
                    + Add Factory
                </button>
            </div>
        </div>
        <div class="filter-container v-center px-3">
            <!-- <div class="toggle-btn">
                <button :class="{ active: selectedTab === 'active' }" @click="selectedTab = 'active'"
                    class="toggle-option">Active</button>
                <button :class="{ active: selectedTab === 'inactive' }" @click="selectedTab = 'inactive'"
                    class="toggle-option">Inactive</button>
            </div> -->
            <div class="filter-right">
                <div>
                    <label for="">Sort By</label>
                    <select v-model="selectedSort" class="sort" name="" id="">
                        <option value="1">Latest</option>
                        <option value="2">Oldest</option>
                    </select>
                </div>
                <div class="input-group search ml-4">
                    <input class="input-search" v-model="searchKeyword" @input="updateOnSearch" type="text"
                        placeholder="Search" />
                </div>
            </div>
        </div>
        <!-- <div v-if="selectedFactory">
            <div class="factory-details">
                <h2>Selected Factory Details</h2>
                <p>Name: {{ selectedFactory.name }}</p>
            </div>
        </div> -->
        <div class="project-list-container my-5 px-3">
            <factory-table :projectList="getSearchResult" :perPage="perPage" :pageNumber="pageNumber" :showHeader="true"
                :loading="loading" :collaborator="collaborator" @edit="openEditFactory"
                @factory-selected="handleFactorySelection"></factory-table>
            <div class="v-center space-between mt-3">
                <pagination2 :length="getSearchResult.length" :pageNumber="pageNumber" :perPage="perPage" @selectPage="selectPage"
                    class="mt-3 mx-2" />
                <span class="mt-5">Total Factories : &nbsp; <b class="mr-5"> {{ getSearchResult.length }}</b></span>
            </div>
        </div>
        <modal :open="createFactoryModalObject.open" @close="createFactoryModalObject.open = false"
            :title="factoryData.id ? 'Update Factory' : 'Create Factory'">
            <create-factory @new-factory-created="handleNewFactoryCreated" v-if="createFactoryModalObject.open"
                :factoryData="factoryData" @cancel="closeCreateFactoryModal" :action="createFactoryModalObject.action"/>
        </modal>
    </div>
</template>
<script>
import {
  GetAllFactories
} from '@/api'
import { factoryExchangeToken, getTokenStorage } from '@/api/session'
import Modal from '@/components/common/modal.vue'
import CreateFactory from '@/components/factoryManagement/createFactory.vue'
import { arraySearch } from '@/utils/array'
import Pagination2 from '@/components/common/pagination2.vue'
import { mapGetters } from 'vuex'
import { alert } from '@/plugins/notification'
// import { debounce } from '@/utils/debounce'
import FactoryTable from '@/components/factoryManagement/factoryTable.vue'
import jwtDecode from 'jwt-decode'
import Config from '@/config'

export default {
  name: 'FACTORY',
  components: { FactoryTable, Pagination2, Modal, CreateFactory },
  data () {
    return {
      length: 50,
      first: 1,
      second: 10,
      selectedTab: 'active',
      selectedSort: '1',
      drawer: false,
      openId: null,
      searchKeyword: '',
      projectList: [],
      pageNumber: 1,
      perPage: 10,
      loading: false,
      status: '',
      buttonDisabled: false, // this for disabling update button  of project updation
      updateOnSearch: null,
      totalcount: 0,
      createFactoryModalObject: {
        open: false,
        action: 'create'
      },
      factoryData: {},
      selectedFactory: {}
    }
  },
  computed: {
    ...mapGetters(['user', 'getUserById', 'collaborator', 'isOnFactoryLevel', 'isOnProjectLevel']),
    getSearchResult () {
      return arraySearch(this.projectList, this.searchKeyword, { fieldsToSearch: ['name'] })
    },
    canCreate () {
      return (this.user.tenantLevelRole === 'ADMIN' && !this.collaborator && !this.isOnFactoryLevel && !this.isOnProjectLevel)
    },
    showProjectAction () {
      return (
        this.user.tenantLevelRole === 'ADMIN' ||
                this.user.tenantLevelRole === 'EDITOR' ||
                this.user.tenantLevelRole === 'COLLABORATOR'
      )
    }
  },
  watch: {
    selectedSort (value) {
      if (value === '0') return
      this.getAllFactoriesList()
    },
    selectedTab () {
      this.getAllFactoriesList()
    }
  },
  methods: {
    handleFactorySelection (factory) {
      factoryExchangeToken(factory.id, (id) => {
        this.$store.commit('setCurrentFactory', factory)
        const storage = getTokenStorage()
        const factoryToken = storage.getItem(Config.localstorageKeys.FACTORY)
        const dtxfactoryObject = jwtDecode(factoryToken)
        const factoryLevelRole = dtxfactoryObject['x-hasura-default-role'].split('-').pop().toUpperCase()
        this.$store.commit('setUserFactoryLevelRole', factoryLevelRole)
        this.selectedFactory = factory
        this.$router.push('/forms')
      })
    },
    selectPage (pageNumber) {
      this.pageNumber = pageNumber
    },
    openCreateFactory () {
      this.factoryData = {}
      this.createFactoryModalObject.open = true
      this.createFactoryModalObject.action = 'create'
    },
    openEditFactory (factory) {
      this.factoryData = factory
      this.createFactoryModalObject.open = true
      this.createFactoryModalObject.action = 'edit'
    },
    closeCreateFactoryModal () {
      this.createFactoryModalObject.open = false
    },
    handleNewFactoryCreated () {
      this.createFactoryModalObject.open = false
      this.getAllFactoriesList()
    },
    getAllFactoriesList () {
      this.loading = true
      GetAllFactories(this.selectedSort, this.selectedTab, this.searchKeyword)
        .then((res) => {
          this.projectList = res.core_projects
          for (const factory of this.projectList) {
            const supervisors = factory.project_user_associations.filter(association => association.role_id === Config.USER_ROLE_MAP.SUPERVISOR)
            const supervisorsCount = supervisors.length
            if (supervisorsCount <= 3) {
              factory.formattedSupervisors = supervisors
            } else {
              factory.formattedSupervisors = supervisors.slice(0, 3)
              factory.exceededCount = supervisorsCount - 3
            }
          }
          this.loading = false
          this.totalcount = res.core_projects_aggregate.aggregate.count
        })
        .catch((error) => {
          console.log(error)
          alert('Something went wrong')
          this.loading = false
        })
    }
  },
  created () {
    // this.updateOnSearch = debounce(() => {
    //   this.pageNumber = 1
    //   this.getAllFactoriesList()
    // }, 500)
    this.getAllFactoriesList()
  }
}
</script>
<style lang="scss" scoped>
.project-list {
    height: 70%;
    margin: 0;

    .filter-container {
        // background-color: green;
        margin-top: 1em;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        width: 100%;
        height: 2rem;

        // background-color: purple;
        // margin-top: 1em;
        // display: flex;
        // justify-content: flex-end;
        // gap: auto;
        // align-items: center;
        .toggle-btn {
            height: 2.2em;
            display: inline-flex;
            border: 1px solid #ccc;
            border-radius: 6px;
            background-color: #e0e0e0;
            align-items: center;
            overflow: hidden;
            position: relative;
        }

        .toggle-option {
            flex: 1;
            padding: 6px 14px;
            border: none;
            background-color: #e0e0e0;
            cursor: pointer;
            font-size: var(--text-base);
            font-weight: 400;
            position: relative;
            z-index: 1;
        }

        .toggle-option.active {
            background-color: white;
            color: black;
            border: 2px solid #bbb;
            transition: all 0.15s ease-in-out;
            border-radius: 6px;
            z-index: 2;
        }

        .toggle-option:first-child.active {
            box-shadow: 4px 0 6px -2px rgba(0, 0, 0, 0.4);
        }

        .toggle-option:last-child.active {
            box-shadow: -4px 0 6px -2px rgba(0, 0, 0, 0.4)
        }

        .filter-right {
            display: flex;
            align-items: center;
            gap: 10px;
            /* Adjust spacing */
        }

        .sort {
            height: 2em;
            width: 10rem;
            margin: 0 0 0 10px;
            // margin-left: 2px;
            font-size: var(--text-base);
            background-color: var(--brand-light-color);
            line-height: 1;
            border: 1px solid var(--brand-color);
            border-radius: 4px;
            padding: 4px 12px;
        }

        .input-search {
            height: fit-content;
        }
    }

    .project-form-container {
        height: 100%;
    }

    .drawer {
        top: 60px;
        overflow-y: auto;
    }

    @media screen and (max-width: 1366px) {

        .add-btn .btn {
            font-size: var(--text-base);
            padding: 6px 12px;
        }
    }

    @media screen and (max-width: 1200px) {

        .add-btn .btn {
            font-size: var(--text-m);
            padding: 5px 10px;
        }
    }

    @media screen and (max-width: 1024px) {

        .add-btn .btn {
            font-size: var(--text-s);
            padding: 4px 8px;
        }
    }
}
</style>
